import LegalLayout from "@/pages/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout
      title="Privacy Policy"
      updated="December 2025"
      lead="Craig Maloney Inc. (&quot;we,&quot; &quot;us,&quot; or &quot;our&quot;) respects your privacy. This policy explains what information we collect through craigmaloney.com, how we use it, and the choices you have."
      seo={{
        title: "Privacy Policy | Craig Maloney Inc.",
        description:
          "How Craig Maloney Inc. collects, uses, and protects information submitted through craigmaloney.com.",
        canonical: "https://craigmaloney.com/privacy",
        og: {
          title: "Privacy Policy | Craig Maloney Inc.",
          description: "How we collect, use, and protect your information.",
          type: "website",
          url: "https://craigmaloney.com/privacy",
        },
      }}
      sections={[
        {
          heading: "Information We Collect",
          paragraphs: [
            "We collect information you voluntarily provide and information collected automatically as you use the site:",
          ],
          bullets: [
            "Information you provide: your email address and the answers you submit when you use tools such as our free assessment or the strategy request form.",
            "Business details you enter: information about your company (for example, business name, model, and marketing inputs) used to generate your results.",
            "Automatically collected data: standard technical information such as IP address, browser type, device, pages visited, and referring URLs, gathered through cookies and similar technologies.",
          ],
        },
        {
          heading: "How We Use Your Information",
          bullets: [
            "To provide and operate the site and its tools, including generating your assessment score and strategy outputs.",
            "To send you the reports or materials you request and to follow up about our services.",
            "To improve, secure, and analyze the performance of the site.",
            "To comply with legal obligations and enforce our terms.",
          ],
        },
        {
          heading: "Cookies & Analytics",
          paragraphs: [
            "We use cookies and analytics tools to understand how the site is used and to improve it. You can control cookies through your browser settings; disabling them may affect how parts of the site function.",
          ],
        },
        {
          heading: "Third-Party Services",
          paragraphs: [
            "We use third-party providers to help operate the site — for example, hosting, analytics, scheduling, and the AI systems that power our strategy tools. These providers process data on our behalf and are expected to protect it. We do not sell your personal information.",
          ],
        },
        {
          heading: "Data Retention & Security",
          paragraphs: [
            "We retain information for as long as needed to provide our services and for legitimate business or legal purposes, then delete or anonymize it. We use reasonable administrative and technical safeguards to protect your information, though no method of transmission or storage is completely secure.",
          ],
        },
        {
          heading: "Your Choices & Rights",
          paragraphs: [
            "You may request access to, correction of, or deletion of your personal information, and you can opt out of marketing communications at any time by using the unsubscribe link or contacting us. Depending on where you live, you may have additional rights under applicable privacy laws.",
          ],
        },
        {
          heading: "Children's Privacy",
          paragraphs: [
            "The site is intended for business users and is not directed to children under 16. We do not knowingly collect information from children.",
          ],
        },
        {
          heading: "Changes to This Policy",
          paragraphs: [
            "We may update this policy from time to time. Material changes will be reflected by updating the date at the top of this page.",
          ],
        },
        {
          heading: "Contact",
          paragraphs: [
            "Questions about this policy or your information can be directed to Craig Maloney Inc. through the contact options on craigmaloney.com.",
          ],
        },
      ]}
    />
  );
}
